export enum StepperActionsType {
  NEXT_STEP = '[Stepper] Go to the next step',
  PREV_STEP = '[Stepper] Return to the previous step',
  GO_TO_STEP = '[Stepper] Go to a specific step',
  RESET_STEPPER = '[Stepper] Reset stepper',
  TOOGLE_STEP_VALID = '[Stepper] Toogle step valid',
  TOOGLE_STEPPER_ACTIVE = '[Stepper] Toogle stepper active'
}
